import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import {
  ConsoleManagerGuard,
  ConsoleMembersPage,
  consoleContextQueryOptions,
  consoleMemberRolesQueryOptions,
  consoleMembersQueryOptions,
} from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/members")({
  // Intent preload — roster + role catalog (fire-and-forget). The gate context
  // IS awaited (returned) so the ConsoleManagerGuard's capability tier is warm
  // before render — no flash of the Membri page for a Sviluppatore.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleMembersQueryOptions());
    void queryClient.ensureQueryData(consoleMemberRolesQueryOptions());
    return queryClient.ensureQueryData(consoleContextQueryOptions());
  },
  component: ConsoleMembersRoute,
});

function ConsoleMembersRoute(): React.ReactElement {
  return (
    <ConsoleManagerGuard>
      <ConsoleMembersPage />
    </ConsoleManagerGuard>
  );
}
